import * as React from "react";
import "./Mobile.css"; 
import Footer from "./Footer.js";

function Mobile() { 
  return (
    <>
      <div className="kiy-home-x">
        <div className="div-x background-container-x">
          <div className="small-container-x">
            <div className="title-section-x">
              <div className="image-x" />
              <div className="content-x">
                <div className="trust-no-othersbut-yourself-x">
                  Trust No Others but Yourself
                </div>
                <br />
                <br />
                <div className="yourcryptocurrenciesyourdigitalassetsyoursensitivedatayourprivacyinformationandyouridentityinformation-x">
                with your digital assets, private data, or identity information.
                </div>
              </div>
              <div className="actions-x">
                <a 
                  href="https://mail.google.com/mail/?view=cm&fs=1&to=partnership@keepityourself.com" 
                  target="_blank" 
                  rel="noopener noreferrer" 
                  style={{
                    textDecoration: "none", // Remove underline
                    color: "black" // Set font color to black
                  }}
                >
                  <div className="button-x">Partner Up with KIY</div>
                </a>
              </div>
              <br />
            </div>
            <img
              loading="lazy"
              srcSet="https://cdn.builder.io/api/v1/image/assets/TEMP/5e1c10e3ed9bc65ce4b458780ac5474ede634b5f?placeholderIfAbsent=true&apiKey=e575051869da42d9bfd064276f858a0b&width=100 100w, https://cdn.builder.io/api/v1/image/assets/TEMP/5e1c10e3ed9bc65ce4b458780ac5474ede634b5f?placeholderIfAbsent=true&apiKey=e575051869da42d9bfd064276f858a0b&width=200 200w, https://cdn.builder.io/api/v1/image/assets/TEMP/5e1c10e3ed9bc65ce4b458780ac5474ede634b5f?placeholderIfAbsent=true&apiKey=e575051869da42d9bfd064276f858a0b&width=400 400w, https://cdn.builder.io/api/v1/image/assets/TEMP/5e1c10e3ed9bc65ce4b458780ac5474ede634b5f?placeholderIfAbsent=true&apiKey=e575051869da42d9bfd064276f858a0b&width=800 800w, https://cdn.builder.io/api/v1/image/assets/TEMP/5e1c10e3ed9bc65ce4b458780ac5474ede634b5f?placeholderIfAbsent=true&apiKey=e575051869da42d9bfd064276f858a0b&width=1200 1200w, https://cdn.builder.io/api/v1/image/assets/TEMP/5e1c10e3ed9bc65ce4b458780ac5474ede634b5f?placeholderIfAbsent=true&apiKey=e575051869da42d9bfd064276f858a0b&width=1600 1600w, https://cdn.builder.io/api/v1/image/assets/TEMP/5e1c10e3ed9bc65ce4b458780ac5474ede634b5f?placeholderIfAbsent=true&apiKey=e575051869da42d9bfd064276f858a0b&width=2000 2000w, https://cdn.builder.io/api/v1/image/assets/TEMP/5e1c10e3ed9bc65ce4b458780ac5474ede634b5f?placeholderIfAbsent=true&apiKey=e575051869da42d9bfd064276f858a0b" 
              className="img-2-x"
              alt="Image representing Trust No Others but Yourself"
            />
          </div>
          <br />
          <br />
          <br />
          <br />
          <div className="relyonsomeonewhotechnicallybetterthanyoutosafeguardyourassetsoryourprivacyyouareneversafe-doityourselfandkeepsecuritytoyourself-x">
          If you rely on someone technically better than you to safeguard your assets or privacy, you will never be truly secure.
          </div>
          <br />
          <br />
          <div className="if-you-involve-someone-x">Keep security to yourself.</div>
          <br />
          <div className="kiy-keep-it-yourself-x">KIY, Keep It Yourself</div>
          <br />
          <div className="your-web-3-securitypartnerhelpyoutosafeguardyourassetsyourdataandyouridentityyourself-x">
          your Web3 security partner
          </div>
        </div>
        <Footer />
      </div>
    </>
  );
}

export default Mobile;